import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.contentHTML)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isHTML)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              flat: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_QuillEditor, {
                      content: _ctx.contentDelta,
                      "onUpdate:content": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.contentDelta) = $event)),
                      contentType: "delta",
                      theme: "snow",
                      toolbar: "full",
                      style: {"overflow-y":"auto","height":"200px"}
                    }, null, 8, ["content"]),
                    _createTextVNode(" " + _toDisplayString(_ctx.contentDelta), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.isHTML)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 1,
              height: "100%",
              flat: ""
            }, {
              default: _withCtx(() => [
                (!_ctx.type)
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          content: _ctx.contentHTML,
                          "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.contentHTML) = $event)),
                          contentType: "html",
                          theme: "snow",
                          toolbar: "full",
                          style: {"overflow-y":"auto","height":"400px"}
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type==='Note')
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          content: _ctx.contentHTML,
                          "onUpdate:content": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contentHTML) = $event)),
                          contentType: "html",
                          theme: "snow",
                          toolbar: "full",
                          style: {"overflow-y":"auto","height":"400px"}
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type==='Discharge Summary')
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          content: _ctx.contentHTMLDischarge,
                          "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.contentHTMLDischarge) = $event)),
                          contentType: "html",
                          theme: "snow",
                          toolbar: "full",
                          style: {"overflow-y":"auto","height":"400px"}
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.type==='Medical Certificate')
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 3 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          content: _ctx.contentHTMLMedCert,
                          "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contentHTMLMedCert) = $event)),
                          contentType: "html",
                          theme: "snow",
                          toolbar: "full",
                          style: {"overflow-y":"auto","height":"400px"}
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.noteItems.includes(_ctx.type))
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 4 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuillEditor, {
                          content: _ctx.contentHTML,
                          "onUpdate:content": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contentHTML) = $event)),
                          contentType: "html",
                          theme: "snow",
                          toolbar: "full",
                          style: {"overflow-y":"auto","height":"400px"}
                        }, null, 8, ["content"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}